import { SignupDetail } from '../../components/Signup'

import { signInUpServiceConfig } from '../shared/config'
import injectWidget from '../shared/injectWidget'

export default injectWidget({
  widget: SignupDetail,
  serviceConfig: signInUpServiceConfig,
})
